import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/maximo-app-framework/maximo-autoscript-documentation/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Customers often need to add new Message Driven Beans for consuming messages from an external JMS server.
Maximo scripted MDBs from 7.6.1.3 or 8.8. `}</p>
    <p>{`To set up MDB with scripting:`}</p>
    <ol>
      <li parentName="ol">{`Create the following vanilla py script (for example, named as CUSTMDB).`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-python"
      }}>{`service.log("msg received with id "+str(jmsmsg.getJMSMessageID()))
`}</code></pre>
    <p>{`Note that `}<inlineCode parentName="p">{`jmsmsg`}</inlineCode>{` refers to the `}<inlineCode parentName="p">{`javax.jms.Message`}</inlineCode>{` object representing the message from the JMS queue.`}</p>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li">{`Assume that you are going to consume message from an external continous queue named extcqin. Therefore, you will use the external system EXTSYS1 to import a file. For example, you import an asset with the content.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Modify the mboejb ejb jar xml to add a script MDB using the ejb-jar.xml file. This connects the script to the MDB.`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-xml"
      }}>{`    <message-driven id="MessageDriven_JMSContQueueProcessor_3">
      <ejb-name>JMSScriptListenerBean-1</ejb-name>
      <ejb-class>psdi.iface.jms.JMSScriptListenerBean</ejb-class>
      <transaction-type>Container</transaction-type>
      <message-destination-type>javax.jms.Queue</message-destination-type>
                  <env-entry>
            <env-entry-name>SCRIPTNAME</env-entry-name>
            <env-entry-type>java.lang.String</env-entry-type>
            <env-entry-value>CUSTMDB</env-entry-value>
              </env-entry>      
    </message-driven>
`}</code></pre>
    <p>{`Note the ejb class `}<inlineCode parentName="p">{`psdi.iface.jms.JMSScriptListenerBean`}</inlineCode>{` and the env entry `}<inlineCode parentName="p">{`SCRIPTNAME`}</inlineCode>{` has the name of the script.
A script on an object structure such as MXITEM, can impact the processing of item data through REST, application Import, Enterprise Service and Invocation/Publish Channel.`}</p>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Deploy the customization. `}</li>
    </ol>
    <p>{`Assuming that the activation spec and queue setup are all done, you should be able to see the log statement appear as you start pushing messages into the queue.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      